// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"162":"70b18ec3","373":"d4eb66f0","405":"d4eb66f0","949":"c7efc5ff"}[chunkId] + ".chunk.css";
};